import { Component, Input, OnInit } from '@angular/core';
import { NbMenuService, NbSidebarService } from '@nebular/theme';
import { UserService } from '../../../@core/data/users.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../services/login.service';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  @Input() position = 'normal';

  user: any;
  userDetails: any;
  showHeader: number;
  imageURL: any;
  subscriptionType: string;
  showOptions = true;

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private data: LoginService) {
  }

  ngOnInit() {

    this.data.imageURL.subscribe(message => {
      this.imageURL = message;
    });

    this.imageURL = sessionStorage.getItem('image');
    if (this.imageURL == '' || this.imageURL == 'undefined' || this.imageURL == 'null') {
      this.imageURL = '../../../../assets/images/user-image.png';
    }

    this.userService.getUsers()
      .subscribe((users: any) => this.user = users.nick);
    this.userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
    if (this.userDetails != null) {
      this.showHeader = 1;
    } else {
      this.showHeader = 0;
    }

    this.subscriptionType = sessionStorage.getItem('subscriptionType') != 'null' ? sessionStorage.getItem('subscriptionType') : '';
    this.showOptions = parseInt(sessionStorage.getItem('isAgreementAccepted')) ? true : false;
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  toggleSettings(): boolean {
    this.sidebarService.toggle(false, 'settings-sidebar');
    return false;
  }

  goToHome() {
    this.menuService.navigateHome();
  }

  gotoMyProfile() {
    this.router.navigate(['../pages/profile/my-profile/'], { relativeTo: this.route });
  }

  logout() {
    // const userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
    this.sisenseLogout(sessionStorage.getItem('jwtToken'));
    sessionStorage.removeItem('loginClickStatus');
    sessionStorage.removeItem('currentUserEmail');
    sessionStorage.removeItem('Authorization');
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  sisenseLogout(jwtToken) {
    const headerData = {
      Authorization: 'Bearer ' + jwtToken,
    };

    const reqHeader = new HttpHeaders(headerData);
    this.data.logoutSisenseUser(reqHeader);
  }
}
